import React, { useState } from "react";
import "../Styles/UserResponse.css";
import "../Styles/Form/Responces.css";
import {
  CheckBox,
  CheckBoxGrid,
  DateAndTime,
  DateQuestion,
  Dropdown,
  Email,
  FileUpload,
  VAFileUpload,
  GridBox,
  LineScale,
  MultipleChoice,
  Name,
  Number,
  ParagraphAnswer,
  Phone,
  Ratings,
  ShortAnswer,
  Signature,
  Spinner,
  Website,
  Location,
} from "../Components/Form/UserResponse/UserResponseComponents";
import { useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateResponse } from "../Redux/Reducer/ResponseSlices";

const UserResponsePage = ({ children }) => {
  const [question, setQuestion] = useState(null);
  const formId = useParams();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalSections, setTotalSection] = useState(0);
  const [responsesCount, setResponsesCount] = useState(0);
  const nevigation = useNavigate();
  console.log(formId);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API;
    const fetchForm = async () => {
      try {
        const response = await axios.get(`${baseUrl}/forms/${formId.formId}`);  
        const fetchedData = response.data.form;
        if (fetchedData.generalSettings?.quizSettings?.shuffleQuestions) {
          // Shuffle questions within each section
          const shuffledSections = fetchedData.sections.map((section) => {
            return {
              ...section,
              questions: shuffleQuestions(section.questions), // Shuffle questions here
            };
          });
          // Update the form with shuffled questions
          setQuestion({ ...fetchedData, sections: shuffledSections });
          
        } else {
          console.log(fetchedData);
          setQuestion(fetchedData);
        }

        setTotalSection(response.data.form.sections.length);
        setResponsesCount(response.data.formResponsesCount);
      } catch (error) {
        console.log(error);
        console.error("Error fetching form:", error);
      }
    };
    fetchForm();
  }, []);

  //check date and time
  const combineDateAndTime = (date, time) => {
    // Split time into hours and minutes
    const [hours, minutes] = time.split(":");

    // Create a new Date instance based on the given date
    const baseDate = new Date(date);

    // Combine date and time explicitly in UTC
    const combinedDateTime = new Date(
      baseDate.getUTCFullYear(),
      baseDate.getUTCMonth(),
      baseDate.getUTCDate(),
      hours, // Hours (from time)
      minutes, // Minutes (from time)
      0, // Seconds
      0 // Milliseconds
    );

    return combinedDateTime;
  };

  //check form Status
  const checkFormStatus = (generalSettings) => {
    const nowIST = new Date(new Date());

    switch (generalSettings.formStatus) {
      case "enabled":
        return true;

      case "disabled":
        return false;

      case "disableOnDate":
        return (
          nowIST <
          combineDateAndTime(
            generalSettings.disableOnDate,
            generalSettings.disableOnTime
          )
        );
      case "disableOnLimit":
        return responsesCount < generalSettings.responseLimit;

      case "disableOnDateAndLimit":
        return (
          nowIST <
            combineDateAndTime(
              generalSettings.disableOnDate,
              generalSettings.disableOnTime
            ) && responsesCount < generalSettings.responseLimit
        );

      default:
        return false; // Invalid condition
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < totalSections - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const responses = useSelector((state) => state.responses.responses);

  const dispatch = useDispatch();
  const getAnswerValue = (questionId) => {
    const response = responses.responses.find(
      (response) => response.questionId === questionId
    );
    return response ? response.answer : "";
  };

  const handleInputChange = (
    questionId,
    value,
    isMultipleChoice = false,
    isGrid = false,
    rowId = null
  ) => {
    dispatch(
      updateResponse({ questionId, value, isMultipleChoice, isGrid, rowId })
    );
  };

  const uploadFileToS3 = async (file) => {
    try {
      console.log("file", file);
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${process.env.REACT_APP_API}/forms/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data.fileUrls; // Return the file URL from S3
    } catch (error) {
      console.error("Error uploading file:", error);
      throw new Error("Failed to upload file");
    }
  };

  // handel submit
  // const handelSubmitForm = async () => {
  //   try {
  //     const finalResponses = await Promise.all(
  //       responses.responses.map(async (response) => {
  //         if (response.type === "file") {
  //           const fileUrls = await Promise.all(
  //             response.answer.map((file) => uploadFileToS3(file))
  //           );
  //           return { ...response, answer: fileUrls };
  //         }
  //         return response;
  //       })
  //     );
  //     const data = {
  //       // email: responses.email,
  //       responses: finalResponses,
  //     };
  //     // console.log("data", data);
  //     const result = await axios.post(
  //       `${process.env.REACT_APP_API}/forms/without-task/${formId.formId}`,
  //       data
  //     );
  //     console.log(result);
  //     if (result.data.status) {
  //       nevigation(
  //         `/thankspage/${result.data.newUser.formId}/${result.data.newUser._id}`
  //       );
  //       console.log();
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //   }
  // };

  const handelSubmitForm = async () => {
    try {
      const finalResponses = await Promise.all(
        responses.responses.map(async (response) => {
          if (response.type === "file") {
            const fileUrls = await Promise.all(
              response.answer.map((file) => uploadFileToS3(file))
            );
            return { ...response, answer: fileUrls };
          }
          return response;
        })
      );
      const data = {
        // email: responses.email,
        responses: finalResponses,
      };
      // console.log("data", data);
      const result = await axios.post(
        `${process.env.REACT_APP_API}/forms/submit/${formId.formId}`,
        data
      );
      console.log(result);
      if (result.data.status) {
        nevigation(
          `/thankspage/${result.data.newUser.formId}/${result.data.newUser._id}`
        );
        console.log();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  //Shuffle  questions
  const shuffleQuestions = (questions) => {
    const shuffledArray = [...questions]; // Creating a copy of the array to avoid mutating the original array
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ]; // Swap elements
    }
    return shuffledArray;
  };

  if (!question) return <p>Loading form...</p>;
  return (
    <>
      {!checkFormStatus(question.generalSettings) ? (
        <div className="mail-page-foruserResponse">
          <div className="mail-page-foruserResponse-text">
            No longer accepting responses.
          </div>
          <div className="mail-page-foruserResponse-text">
            <p>The form Untitled form is no longer accepting responses.</p>
            <p>
              Try contacting the owner of the form if you think that this is a
              mistake.
            </p>
          </div>
          <div className="bottom-notification-user-response">
            This content is neither created nor endorsed by Stacia. Report Abuse
            - Terms of Service - Privacy Policy
          </div>
        </div>
      ) : (
        <div className="user_Response_container">
          <>
            <Container section={question.sections[currentIndex]}>
              {question.sections[currentIndex].questions.map(
                (eachQuestion, qindex) => (
                  <div key={qindex}>
                    <AllQuestions
                      eachQuestion={eachQuestion}
                      index={qindex}
                      section={question.sections[currentIndex]}
                      getAnswerValue={getAnswerValue}
                      handleInputChange={handleInputChange}
                    />
                  </div>
                )
              )}
            </Container>
            <div className="response_final_stage">
              <div>Clear form</div>
              <div className="btn_container">
                {currentIndex === totalSections - 1 && (
                  <div
                    className="response_final_stage_btn"
                    onClick={handelSubmitForm}
                  >
                    Submit
                  </div>
                )}
                {currentIndex > 0 && (
                  <div
                    className="response_final_stage_btn"
                    onClick={handleBack}
                  >
                    Back
                  </div>
                )}
                {currentIndex < totalSections - 1 && (
                  <div
                    className="response_final_stage_btn"
                    onClick={handleNext}
                  >
                    Next
                  </div>
                )}
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
};

const Container = ({ section, children }) => {
  return (
    <div className="user_from_container">
      <div className="topbar_container">
        <div
          className="individualview_title"
          dangerouslySetInnerHTML={{ __html: section.sectionTitle }}
        ></div>
        <div
          className="individualview_description"
          dangerouslySetInnerHTML={{ __html: section.sectionDescription }}
        ></div>
      </div>
      {children}
    </div>
  );
};
const AllQuestions = ({
  eachQuestion,
  index,
  getAnswerValue,
  handleInputChange,
}) => {
  return (
    <div>
      {renderQuestions(eachQuestion, index, getAnswerValue, handleInputChange)}
    </div>
  );
};
const renderQuestions = (
  eachQuestion,
  index,
  getAnswerValue,
  handleInputChange
) => {
  switch (eachQuestion.type) {
    case "Short Answer":
      return (
        <ShortAnswer
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Paragraph":
      return (
        <ParagraphAnswer
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Multiple Choice":
      return (
        <MultipleChoice
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Check box":
      return (
        <CheckBox
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Multiple Choice grid":
      return (
        <GridBox
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Check box grid":
      return (
        <CheckBoxGrid
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Phone":
      return (
        <Phone
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Name":
      return (
        <Name
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Website":
      return (
        <Website
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Email":
      return (
        <Email
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Number":
      return (
        <Number
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Spinner":
      return (
        <Spinner
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Signature":
      return (
        <Signature
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "File Upload":
      return (
        <FileUpload
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Audio/Video Upload":
      return <VAFileUpload question={eachQuestion} index={index} />;
    case "Date":
      return (
        <DateQuestion
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Date - Time":
      return (
        <DateAndTime
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Ratings":
      return <Ratings question={eachQuestion} index={index} />;
    case "Dropdown":
      return (
        <Dropdown
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Line Scale":
      return (
        <LineScale
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Location":
      return (
        <Location
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    // case "Multiple Choice Video":
    // case "Multiple Choice Image":
    //   return <MultipleChoiceImage question={eachQuestion} index={index} />;
    default:
      return null;
  }
};
export default UserResponsePage;
